<template>
  <DxPopup
    :visible="visible"
    :show-title="true"
    :show-close-button="true"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :title="$t('works.parcels.sync_sessions_title')"
    width="min(1100px, 95vw)"
    height="min(720px, 90vh)"
    @hiding="$emit('close')"
  >
    <DxDataGrid
      :data-source="sessions"
      key-expr="uuid"
      :show-borders="true"
      :show-row-lines="true"
      :column-auto-width="true"
      :row-alternation-enabled="true"
      :no-data-text="$t('works.parcels.sync_sessions_empty')"
      height="100%"
    >
      <DxColumn data-field="created_at" :caption="$t('works.parcels.sync_sessions_date')" data-type="datetime" />
      <DxColumn data-field="success_count" :caption="$t('works.parcels.sync_sessions_success_count')" data-type="number" />
      <DxColumn data-field="skipped_count" :caption="$t('works.parcels.sync_sessions_skipped_count')" data-type="number" />
      <DxMasterDetail :enabled="true" template="sessionDetailTemplate" />
      <template #sessionDetailTemplate="{ data }">
        <DxDataGrid
          :data-source="data.data.rows"
          key-expr="uuid"
          :show-borders="true"
          :show-row-lines="true"
          :column-auto-width="true"
          :row-alternation-enabled="true"
          :no-data-text="$t('works.parcels.sync_sessions_empty')"
        >
          <DxColumn data-field="row_name" :caption="$t('works.parcels.sync_sessions_row_name')" />
          <DxColumn data-field="remote_id" :caption="$t('works.parcels.sync_sessions_remote_id')" />
          <DxColumn data-field="event_type" :caption="$t('works.parcels.sync_history_event')" cell-template="sessionEventTemplate" />
          <template #sessionEventTemplate="{ data: event }">
            {{ $te('works.parcels.sync_history_events.' + event.value) ? $t('works.parcels.sync_history_events.' + event.value) : event.value }}
          </template>
          <DxColumn data-field="reason" :caption="$t('works.parcels.sync_sessions_reason')" />
        </DxDataGrid>
      </template>
    </DxDataGrid>
    <div v-if="loading" class="parcel-sync-sessions-loading">
      {{ $t('common.loading') }}
    </div>
  </DxPopup>
</template>

<script>
import DxPopup from "devextreme-vue/popup";
import { DxColumn, DxDataGrid, DxMasterDetail } from "devextreme-vue/data-grid";

export default {
  name: "ParcelSyncSessionsPopup",
  components: { DxPopup, DxColumn, DxDataGrid, DxMasterDetail },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    sessions: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.parcel-sync-sessions-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  pointer-events: none;
}
</style>